export default __webpack_public_path__ + "static/pict3-3c4e73c421096fc329b232e75a62d4e6.png";